import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HeaderBar from '../common/HeaderBar';
import { Loader, Dimmer } from 'semantic-ui-react';
import {InstantSearch, SearchBox, Hits, SortBy, PoweredBy, Configure} from 'react-instantsearch/dom';


class CharityScreen extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            loading : true
        }

    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    render(){
        return (
            <div className="CharityScreen">
                <HeaderBar />
                <div className="CharityScreen-content">
                
                {(this.state.loading)? <Dimmer inverted active>
                    <Loader>Loading</Loader>
                </Dimmer>
                : null}
                 {/* <InstantSearch
                        apiKey="aa4db728d33cb5c9f9032ac40c2c13d8"
                        appId="R5BM8DSN2Y"
                        indexName="items"
                    >
                        <Configure aroundLatLngViaIP={true}/>
                        <Configure getRankingInfo={true}/>


                        <SearchBox translations={{placeholder : 'Search for your item'}} />
                        {renderViewType()}
                        <PoweredBy />
                    </InstantSearch> */}
                </div>
            </div>
        )
    }
}

CharityScreen.propTypes = {
    
}

const mapStateProps = (state) => {
    return {
    
    };
}

export default  connect(mapStateProps, {  })(CharityScreen);



// WEBPACK FOOTER //
// ./src/components/screens/CharityScreen.js